import React from 'react';
import PropTypes from 'prop-types';
import MultiPicker from '../../common/controls/multiPicker';
const OrganizationFilter = ({
  selectedOrganizations,
  organizations,
  onFilter
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    marginTop: '10px'
  }
}, /*#__PURE__*/React.createElement(MultiPicker, {
  label: "Organization",
  values: selectedOrganizations,
  options: organizations,
  onChange: value => onFilter('organizations', value)
}));
OrganizationFilter.propTypes = {
  organizations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.string
  })).isRequired,
  selectedOrganizations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.string
  })).isRequired,
  onFilter: PropTypes.func.isRequired
};
export default OrganizationFilter;